export enum SellerContractContactType {
  EquipmentContact = 'EquipmentContact'
}
